// src/componentes/Escala11/Competicao/GerenciarCompeticao/index.tsx

import React, { useState } from "react"; // <--- CORRIGIDO: Importação de React e useState
import { Box } from "@mui/material";
import AdicionarCompeticao from "../AdicionarCompeticao";
import ListarCompeticao from "../ListarCompeticao";

// Removidas as importações erradas:
// import { Competition, fetchCompetitions as refetchCompetitionsType } from "../ListarCompeticao";

interface GerenciarCompeticaoProps {
  token: string;
}

const GerenciarCompeticao: React.FC<GerenciarCompeticaoProps> = ({ token }) => {
  // Usando useState importado
  const [shouldRefetch, setShouldRefetch] = useState(0);

  // Função que será chamada após a criação bem-sucedida da competição
  const handleCompetitionCreated = () => {
    console.log(
      "Notificação recebida: Nova competição criada. Atualizando lista..."
    );
    // Incrementando o contador para garantir que o useEffect do ListarCompeticao seja re-executado.
    setShouldRefetch((prev) => prev + 1);
  };

  return (
    <Box>
      {/* Passa o callback para AdicionarCompeticao */}
      <AdicionarCompeticao
        token={token}
        onCompetitionCreated={handleCompetitionCreated}
      />
      {/* Passa o estado de re-fetch para ListarCompeticao */}
      <ListarCompeticao token={token} refetchTrigger={shouldRefetch} />
    </Box>
  );
};

export default GerenciarCompeticao;
